<app-temp-modal-cadastro #modal title="Pedidos Stone" (closed)="onClose()" [textHeader]="'Pedidos Stone'"
  [customClass]="'modal-lg'">
  <div class="app-modal-body">
    <div class="row">
      <div class="col">
        <button class="btn btn-primary" (click)="listarPedidosStone()" [disabled]="loading['acoes'] || loading['listagem']">
          <app-loading [texto]="'Atualizar'" [icone]="'icofont icofont-refresh'" [loading]="loading['listagem']"></app-loading>
        </button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <app-dim-datatable *ngIf="loading['listagem'] || listagem?.data?.length > 0; else elseBlock" [data]="listagem?.data" [columns]="colunas"
          [rowsOnPage]="10" [loading]="loading['listagem']" [totalItems]="listagem?.paging?.total || 0" (pageChanged)="changePage($event)"
          [currentPage]="currentPage" [acoes]="true">

          <ng-template #buttonsMinTmpl #buttonsMaxTmpl let-row="row">
            <button *ngIf="row.status === 'pending' && !row.closed" class="btn btn-danger btn-mini"
              (click)="cancelarPedido(row)" [disabled]="loading['acoes']">
              <app-loading [texto]="'Cancelar'" [loading]="loading['acoes']"></app-loading>
            </button>
            <button *ngIf="row.status === 'paid' && !row.closed" class="btn btn-primary btn-mini"
              (click)="fecharPedido(row)" [disabled]="loading['acoes']">
              <app-loading [texto]="'Fechar pedido'" [loading]="loading['acoes']"></app-loading>
            </button>
          </ng-template>
        </app-dim-datatable>
        <ng-template #elseBlock>Não foi encontrado nenhum registro!</ng-template>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col">
        <button class="btn btn-info" (click)="fechar()" [disabled]="loading['acoes']">
          Fechar
        </button>
      </div>
    </div>
  </div>
</app-temp-modal-cadastro>
